import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { __decorate } from "tslib";
import { getOrderRecord } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { dateTimeFormatter as _dateTimeFormatter, formatNum as _formatNum } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.menus = [{
      title: '提交记录',
      isOpen: true,
      child: [{
        id: 1,
        title: '代打印',
        link: '/user',
        name: 'user'
      }, {
        id: 11,
        title: '耗材定制',
        link: '/coupon',
        name: 'coupon'
      }]
    }];
    _this.name = '';
    _this.orderList = [];
    // 当前页数
    _this.currentpage = 1;
    _this.pageNo = 1;
    _this.pageSize = 10;
    _this.currentIndex = Number(_this.$route.query.currentIndex);
    // 有无数据
    _this.isNodata = false;
    // 总条数
    _this.totalnumber = 10;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getData();
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getOrderRecord({
                showType: this.currentIndex,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                companyId: 1
              });
            case 2:
              res = _context.sent;
              this.orderList = res.data.data.list;
              this.isNodata = this.orderList.length === 0;
              this.totalnumber = res.data.data.total;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }() // 到详情
  }, {
    key: "goDetails",
    value: function goDetails(id) {
      this.$router.push("/consumables-orderdetails?id=".concat(id, "&showType=").concat(this.currentIndex));
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getData();
      window.scrollTo(0, 0);
    }
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(pageNo) {
      this.pageNo = pageNo;
      this.getData();
      window.scrollTo(0, 0);
    }
  }, {
    key: "changeChild",
    value: function changeChild(index) {
      this.currentIndex = index;
      this.pageNo = 1;
      this.pageSize = 10;
      this.currentpage = 1;
      this.getData();
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    BackTop: BackTop
  },
  filters: {
    dateTimeFormatter: function dateTimeFormatter(value) {
      return _dateTimeFormatter(value);
    },
    formatNum: function formatNum(value) {
      return _formatNum(value);
    }
  }
})], default_1);
export default default_1;